/* eslint-disable no-unused-vars */

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import VueToastr from "vue-toastr";
import VueFormly from "vue-formly";
import DateTime from "./vendor/vue-datetime-picker/";
import VueYouTubeEmbed from "vue-youtube-embed";
import fieldInput from "@/components/fields/fieldInput";
import fieldSelect from "@/components/fields/fieldSelect";
import fieldTextarea from "@/components/fields/fieldTextarea";
import fieldCheckbox from "@/components/fields/fieldCheckbox";
import fieldProductTable from "@/components/fields/fieldProductTable";
import fieldPassword from "@/components/fields/fieldPassword";
import fieldColor from "@/components/fields/fieldColor";
import Acl from "@/plugins/acl";
import _ from "lodash";

import App from "./App";
import router from "./router";
import store from "./store";
import filters from "./filters";

import "./assets/scss/main.scss";

import Quill from "quill";
import htmlEditButton from "quill-html-edit-button";
Quill.register({ "modules/htmlEditButton": htmlEditButton });

// inter component communication
window.bus = new Vue();

Vue.config.productionTip = false;

Vue.prototype.$log = console.log;

Vue.use(Acl);
Vue.use(VueYouTubeEmbed);
Vue.use(DateTime);

Vue.prototype.$isImage = function(image) {
  let ext = ((image || {}).name || "").split(".").pop();
  return _.includes(["png", "gif", "jpeg", "jpg"], ext);
};

Vue.prototype.$log = console.log;

/* eslint-disable no-new */
// new Vue({
//   el: '#app',
//   store,
//   router,
//   template: '<App/>',
//   components: { App },
// });

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

Vue.component("vue-toastr", VueToastr);

// add formly and field inputs
Vue.use(VueFormly);
VueFormly.addType("input", fieldInput);
VueFormly.addType("select", fieldSelect);
VueFormly.addType("textarea", fieldTextarea);
VueFormly.addType("checkbox", fieldCheckbox);
VueFormly.addType("productTable", fieldProductTable);
VueFormly.addType("password", fieldPassword);
VueFormly.addType("color", fieldColor);
